import { useQuery } from "@tanstack/react-query";
import { MusicStatistic } from "../types/MusicStatistic";

export function useGetAllMusicStatsForLocation(locationId: number) {
    return useQuery<MusicStatistic[]>(
        [`locations/${locationId}/music-statistics`],
        {
            refetchOnWindowFocus: false,
        }
    );
}
